import constants from "../../constants";

/** "R$ 119,90" → 119.9 */
export const toNumber = (price: string) => Number(price.replace(/[^\d,]/g, "").replace(",", "."));

export const formatBRL = (value: number) => value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

/** What the yearly plan saves against a year of the price before the discount ("R$ 70,90"). */
export const YEARLY_SAVING = formatBRL(toNumber(constants.price.year.oldValue) - toNumber(constants.price.year.value));
